const featureFlags = {
  get hideCallIndicator() {
    return !!window.__amp_feature_flags.hide_call_indicator;
  },
  get dynamicTips() {
    return (
      !!window.__amp_feature_flags.dynamic_tip_on_summary ||
      !!window.__amp_feature_flags.dynamic_tip_on_data_collection ||
      !!window.__amp_feature_flags.dynamic_tip_on_quotes ||
      !!window.__amp_feature_flags.life_insurance_pitch
    );
  },
  get dynamicTipOnSummary() {
    return !!window.__amp_feature_flags.dynamic_tip_on_summary;
  },
  get dynamicTipOnDataCollection() {
    return !!window.__amp_feature_flags.dynamic_tip_on_data_collection;
  },
  get dynamicTipOnQuotes() {
    return !!window.__amp_feature_flags.dynamic_tip_on_quotes;
  },
  get lifeInsurancePitch() {
    return !!window.__amp_feature_flags.life_insurance_pitch;
  },
  get cstGuidedSellingExperience() {
    return !!window.__amp_feature_flags.cst_guided_selling_experience;
  },
  get policyActions() {
    return !!window.__amp_feature_flags.policy_actions;
  },
  get salesDashboardColumnsVisibility() {
    return !!window.__amp_feature_flags.sales_dashboard_columns_visibility;
  },
  get sendDocuments() {
    return !!window.__amp_feature_flags.send_documents;
  },
  get invoicePdfGeneration() {
    return !!window.__amp_feature_flags.invoice_pdf_generation;
  },
  get quotingConfigurationV2Api() {
    return !!window.__amp_feature_flags.quoting_configuration_v2_api;
  },
  get coverageTypeSelectDropdown() {
    return !!window.__amp_feature_flags.coverage_type_select_dropdown;
  },
  get editableNoteTextarea() {
    return !!window.__amp_feature_flags.editable_note_textarea;
  },
  get disableApplicationDocumentSelection() {
    return !!window.__amp_feature_flags.disable_application_document_selection;
  },
  get showPolicyGeniusBookroll() {
    return !!window.__amp_feature_flags.show_policy_genius_bookroll;
  },
  get marketingEmailsInFeed() {
    return !!window.__amp_feature_flags.marketing_emails_in_feed;
  }
};

export default featureFlags;
